/* eslint-disable react-hooks/static-components */
import HeroSection from "./components/HeroSection";
import StatsSection from "./components/StatsSection";
import FeaturesSection from "./components/FeaturesSection";
import BeforeAfterSection from "./components/BeforeAfterSection";
import JourneySection from "./components/JourneySection";
import TestimonialsSection from "./components/TestimonialsSection";
import SuitabilitySection from "./components/SuitabilitySection";
import WrittenTestimonialsSection from "./components/WrittenTestimonialsSection";
import FAQSection from "./components/FAQSection";
import RegistrationSection from "./components/RegistrationSection";
import Footer from "./components/Footer";
import StickyMobileCTA from "./components/StickyMobileCTA";
import { Toaster } from "./components/ui/sonner";

export default function App() {
  const scrollToRegistration = () => {
    const registrationSection = document.getElementById("register");
    if (registrationSection) {
      registrationSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  const SectionDivider = () => (
    <div className="h-[5px] pt-2 bg-gradient-to-r from-transparent via-[#CFAE58] to-transparent -translate-y-1/2 will-change-transform"></div>
  );

  return (
    <div className="min-h-screen bg-[#0A1E3F] text-white overflow-x-hidden antialiased">
      <HeroSection onCTAClick={scrollToRegistration} />
      <SectionDivider />

      <StatsSection />
      <SectionDivider />

      <FeaturesSection onCTAClick={scrollToRegistration} />
      <SectionDivider />

      <BeforeAfterSection onCTAClick={scrollToRegistration} />
      <SectionDivider />

      <JourneySection />
      <SectionDivider />

      <TestimonialsSection onCTAClick={scrollToRegistration} />
      <SectionDivider />

      <SuitabilitySection onCTAClick={scrollToRegistration} />
      <SectionDivider />

      <WrittenTestimonialsSection />
      <SectionDivider />

      <FAQSection />
      <SectionDivider />

      <RegistrationSection />
      <SectionDivider />

      <Footer />
      <StickyMobileCTA onClick={scrollToRegistration} />
      <Toaster position="top-center" />
    </div>
  );
}
